import { fetchWithHandling } from "../../utils/ApiUtils";


const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api/';


//get facilities
export async function getFacilities() {
    return await fetchWithHandling(`${BASE_URL}facilities`, {
        credentials: 'include'
    });
}

//get summary of facilities
export async function getFacilitiesSummary() {
    return await fetchWithHandling(`${BASE_URL}facilities/summary`, {
        credentials: 'include'
    });
}



// fetch pageable facilities with optional filters: { page, size, q, status }
export async function getFacilitiesPage(params = {}) {
    const qs = Object.entries(params).filter(([,v])=>v!==undefined && v!==null && v!=='').map(([k,v])=>`${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
    const url = `${BASE_URL}facilities${qs ? `?${qs}` : ''}`;
    return await fetchWithHandling(url, { credentials: 'include' });
}

//Get facility
export const getFacility = async (facilityId) => {
    return await fetchWithHandling(`${BASE_URL}facilities/${facilityId}`, {
        credentials: 'include'
    });
    
}

export const updateFacility = async (facilityId, facilityData) => {
    return await fetchWithHandling(`${BASE_URL}facilities/${facilityId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(facilityData),
        credentials: 'include'
    });
}


//Delete facility
export async function deleteFacility(facilityId) {
    return await fetchWithHandling(`${BASE_URL}facilities/${facilityId}`, {
        method: 'DELETE',
        credentials: 'include'
    });
}

//Create facility
export async function createFacility(facilityData) {
    return await fetchWithHandling(`${BASE_URL}facilities`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(facilityData),
        credentials: 'include'
    });
}
